export const truncateText = (input, limit) =>
  input && input.length > limit ? `${input.substring(0, limit)}...` : input;
